import React, { useEffect, useState } from "react";
import { Images } from "../../../assets";
import SettingModal from "../settingModal/settingModal";
import {
  Container,
  Dropdown,
  Form,
  Image,
  Nav,
  NavDropdown,
  Navbar,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { config } from "../../../config/config";
import { useTranslation } from "react-i18next";
import SearchDropdown from "./searchDropdown";
import Sidebar from "./sidebar";
import { useLocation } from "react-router-dom";
import "./header.css";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { getSiteSettingData } from "../../../redux/site-settings/action";
import { fetchCategories } from "../../../redux/laws/action";
import { LogoutUser } from "../../../redux/auth/action";
import { helperFunction } from "../../../utils/helperFunctions";

function Header({
  increaseFontSize,
  resetFontSize,
  decreaseFontSize,
  theme,
  darkTheme,
  lightTheme,
  toggleColorlessMode,
  handleGoldenTheme,
  handleGreenTheme,
  handlePrimaryTheme,
  handleLightBlueTheme,
  handleBrownTheme,
  handleResetSetting,
  colorScheme,
}) {
  const [show, setShow] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const law = useSelector((state) => state.law);
  const siteSettings = useSelector((state) => state.siteSettings);
  const { lawTypes } = law;
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { i18n, t } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(config.lngs[0]);

  useEffect(() => {
    dispatch(fetchCategories(1, 10, "Lawlibrary"));
  }, []);

  const handleSelect = (lngCode) => {
    i18n.changeLanguage(lngCode);
    const selected = config.lngs.find((lng) => lng.code === lngCode);
    setSelectedLang(selected);
    localStorage.setItem("selectedLang", JSON.stringify(selected));
  };

  const handleTranslate = () => {
    const nextLanguageCode = selectedLang?.code === "ar" ? "en" : "ar";
    handleSelect(nextLanguageCode);
  };

  const handleLogout = () => {
    if (helperFunction.isAuthenticated()) {
      dispatch(LogoutUser());
    }
    navigate("/login");
  };

  const location = useLocation();
  const noBannerURLs =
    location.pathname.startsWith("/faqs") ||
    location.pathname === "/privacy-policy" ||
    location.pathname === "/intellectual-property-notice" ||
    location.pathname === "/arbitration-clause" ||
    location.pathname === "/compliance-applicable-laws" ||
    location.pathname === "/refund-cancellation-policy" ||
    location.pathname === "/terms-and-conditions" ||
    location.pathname === "/arbitration-form" ||
    location.pathname === "/mediation-form" ||
    location.pathname === "/mediation-request-form" ||
    location.pathname === "/code-of-conduct" ||
    location.pathname === "/fee-calculator" ||
    location.pathname === "/register" ||
    location.pathname === "/apply-arbitrator";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!siteSettings?.siteSettingsData?.length > 0)
      dispatch(getSiteSettingData());
  }, []);

  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLang");
    const initialLang = savedLang ? JSON.parse(savedLang).code : "en";

    i18n.changeLanguage(initialLang);
    setSelectedLang(config.lngs.find((lng) => lng.code === initialLang));
  }, [i18n]);

  useEffect(() => {
    const direction = i18n.dir();
    document.documentElement.setAttribute("dir", direction);

    if (direction === "rtl") {
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
    } else {
      document.body.classList.add("ltr");
      document.body.classList.remove("rtl");
    }
    return () => {
      document.body.classList.remove("rtl", "ltr");
    };
  }, [i18n, i18n.language]);

  return (
    <header
      id="header"
      className={`header postion-relative ${isScrolled || noBannerURLs ? "add-bg" : ""}`}
    >
      <Container className="custom-container">
        <div className="d-flex py-2">
          <Navbar
            expand="xl"
            className="flex-fill rtl-navbar-expand"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            {siteSettings?.loader ? (
              <Skeleton width={100} height={70} />
            ) : (
              <Navbar.Brand
                as={Link}
                to="/"
                className="p-0 navbar-class rtl-navbar"
                id="header-logo"
              >
                <Image
                  src={
                    siteSettings?.siteSettingsData?.logo ||
                    Images.WhiteHeaderLogo
                  }
                  alt="logo"
                  loading="lazy"
                  fluid
                />
              </Navbar.Brand>
            )}
            <Navbar.Collapse
              id="responsive-navbar-nav"
              className="d-xl-block d-none"
            >
              <Nav className="my-0 align-items-center" id="main-menu">
                <Nav.Link as={Link} to="/home">
                  {t("nav.home")}
                </Nav.Link>
                {/* <NavDropdown title="e-Services" className="e-services">
                  <NavDropdown.Item as={Link} to="/membership">
                    Memberships
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/arbitration"
                  >
                    Arbitration Request Form
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/claim"
                  >
                    Claim Statement Form
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="#action4">
                    Request The Arbitrator’s Response
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/intervention"
                  >
                    Intervention Request Form
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/interpretation"
                  >
                    Interpretation Request Form
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/joinder"
                  >
                    Joinder Request Form
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="#action4">
                    Objection Request
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/dashboard/e-services/request/copy"
                  >
                    Request A True Copy Of The Ruling
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="#action3">
                    Request A Statement/Certificate
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="#action4">
                    Request To Select An Arbitrator Outside The Center’s List Of
                    Accredited Arbitrators
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="#action5">
                    An Arbitration Request That Is Not Subject To The Centre’s
                    Rules And Regulations
                  </NavDropdown.Item>
                </NavDropdown> */}
                <NavDropdown title={t("nav.aboutUs")}>
                  <NavDropdown.Item as={Link} to="/about-us">
                    {t("nav.aboutUs")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/chairman-message">
                    {t("nav.chairmanMessage")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/general-secretary-message">
                    {t("nav.generalSecretaryMessage")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/committee-members">
                    {t("nav.committeeMembers")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/work-teams">
                    {t("nav.workTeam")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/partners">
                    {t("nav.partners")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/arbitration-uae">
                    {t("nav.arbitrationInUAE")}
                  </NavDropdown.Item>

                  {/* <NavDropdown.Item as={Link} to="/jury-panel">
                    Jury Panel
                  </NavDropdown.Item> */}
                  {/* <NavDropdown.Item as={Link} to="/law-library">
                    The Laws
                  </NavDropdown.Item> */}
                </NavDropdown>
                <NavDropdown title={t("nav.ourServices")}>
                  {/* <NavDropdown.Item as={Link} to="/services">
                  ADR Services
                  </NavDropdown.Item> */}
                  <NavDropdown.Item as={Link} to="/arbitration">
                    {t("nav.arbitration")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/mediation">
                    {t("nav.mediation")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/technical">
                    {t("nav.technicalPage")}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    to="/arbitration-mediation-logistics"
                  >
                    {t("nav.logisticPage")}
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title={t("nav.adrServices")}>
                  {/* <NavDropdown.Item as={Link} to="/services">
                  ADR Services
                  </NavDropdown.Item> */}
                  <NavDropdown.Item as={Link} to="/arbitration">
                    {t("nav.arbitration")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/mediation">
                    {t("nav.mediation")}
                  </NavDropdown.Item>
                  <NavDropdown
                    title={t("nav.technicalAndLogistic")}
                    className="sub-dropdown"
                  >
                    <NavDropdown.Item as={Link} to="/technical">
                      {t("nav.technicalPage")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/arbitration-mediation-logistics"
                    >
                      {t("nav.logisticPage")}
                    </NavDropdown.Item>
                  </NavDropdown>
                  {/* <NavDropdown.Item as={Link} to="/departments-Of-Center">
                    Departments Of The Center
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/center-tables">
                    Center Tables
                  </NavDropdown.Item> */}
                </NavDropdown>
                <NavDropdown title={t("nav.arbitrators")}>
                  <NavDropdown.Item as={Link} to="/arbitrator">
                    {t("nav.arbitrator")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/apply-expert">
                    {t("nav.expert")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/code-of-conduct">
                    {t("nav.codeOfConduct")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/member-of-arbitrators">
                    {t("nav.ourMemberArbitratorsExperts")}
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item as={Link} to="/fee-calculator">
                    E-Calculator fees
                  </NavDropdown.Item> */}
                  {/* <NavDropdown.Item as={Link} to="/departments-Of-Center">
                    Departments Of The Center
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/center-tables">
                    Center Tables
                  </NavDropdown.Item> */}
                </NavDropdown>
                {/* <Nav.Link as={Link} to="/media-center">
                  Media Center
                </Nav.Link> */}
                <NavDropdown title={t("nav.mediaCenter")}>
                  <NavDropdown.Item as={Link} to="/legal-article">
                    {t("nav.legalArticles")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/news">
                    {t("nav.news")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/photo-albums">
                    {t("nav.gallery")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/videos">
                    {t("nav.videos")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/events">
                    {t("nav.events")}
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/workshops">
                    {t("nav.workshops")}
                  </NavDropdown.Item>
                  <NavDropdown
                    title={t("nav.courses")}
                    className="sub-dropdown"
                  >
                    <NavDropdown.Item as={Link} to="/conference">
                      {t("nav.conference")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/arbitration-training-program"
                    >
                      {t("nav.arbitrationTrainingProgram")}
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/seminar">
                      {t("nav.seminar")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/diploma-course-of-international-arbitration"
                    >
                      {t("nav.arbitrationProgramAndDiploma")}
                    </NavDropdown.Item>
                  </NavDropdown>
                  {/* <NavDropdown.Item as={Link} to="/courses">
                    Training Courses
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/seminars">
                    Seminars & Conferences
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/libraries">
                    Electornic Library
                  </NavDropdown.Item> */}
                </NavDropdown>
                <NavDropdown title={t("nav.lawLibrary")}>
                  <NavDropdown.Item as={Link} to="/law-library">
                    {t("nav.lawLibrary")}
                  </NavDropdown.Item>
                  {lawTypes &&
                    lawTypes?.categoriesList
                      ?.filter((item) =>
                        ["Arbitration", "Mediation", "Conventions"].includes(
                          item?.title,
                        ),
                      )
                      .map((item, index) => {
                        // const linkTo =
                        //   item?.title === "Arbitration"
                        //     ? `/law/album/${item?.id}`
                        //     : `/law/${item?.id}`;

                        return (
                          <NavDropdown.Item
                            as={Link}
                            to={`/law/${item?.id}`}
                            key={index}
                          >
                            {item?.title}
                          </NavDropdown.Item>
                        );
                      })}
                </NavDropdown>

                {/* <Nav.Link as={Link} to="/law-library">
                  Law library
                </Nav.Link> */}
                <Nav.Link as={Link} to="/contact-us">
                  {t("nav.contactUs")}
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <Nav
              className="flex-row flex-shrink-0 gap-xxl-3 gap-2 me-xxl-3 me-lg-2"
              id="personalization"
            >
              <Nav.Item role="button" onClick={handleShow}>
                <Image
                  src={Images.settingIcon}
                  alt="icon"
                  loading="lazy"
                  fluid
                />
              </Nav.Item>
              <Nav.Item role="button" onClick={handleTranslate}>
                <Image
                  className="ar-lang"
                  src={Images.arLangIcon}
                  alt="icon"
                  loading="lazy"
                  fluid
                />
                <Image
                  className="en-lang"
                  src={Images.enLangIcon}
                  alt="icon"
                  loading="lazy"
                  fluid
                />
              </Nav.Item>
              <Dropdown className="user-dropdown position-relative">
                <Dropdown.Toggle variant="none" className="user-icon">
                  <Image
                    src={Images.userIcon}
                    alt="icon"
                    loading="lazy"
                    fluid
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item as={Link} to="/profile">
                    {t("nav.profile")}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogout}>
                    {t("nav.logout")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <SearchDropdown />
            </Nav>
            <Sidebar />
          </Navbar>
        </div>
      </Container>
      <SettingModal
        increaseFontSize={increaseFontSize}
        resetFontSize={resetFontSize}
        decreaseFontSize={decreaseFontSize}
        theme={theme}
        darkTheme={darkTheme}
        lightTheme={lightTheme}
        colorScheme={colorScheme}
        toggleColorlessMode={toggleColorlessMode}
        show={show}
        handleClose={handleClose}
        handleGoldenTheme={handleGoldenTheme}
        handleGreenTheme={handleGreenTheme}
        handlePrimaryTheme={handlePrimaryTheme}
        handleLightBlueTheme={handleLightBlueTheme}
        handleBrownTheme={handleBrownTheme}
        handleResetSetting={handleResetSetting}
      />
    </header>
  );
}

export default Header;
